<template>
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :fill="fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411
      0 18C0 8.05887 8.05887 0 18 0C27.9411 0 36 8.05887 36
      18ZM8.30742 8.86154L14.954 8.86154L17.4459 8.86154L17.4463
      8.86154V18H14.954V11.3538H8.30742V8.86154ZM8.30742
      18.8308H17.4459V18.8308H17.4463V27.9692H14.954V21.3231H8.30742V18.8308ZM18.2771
      18.8308H27.4156V21.3231H27.4151V27.9692H24.9228V21.3231H18.2771V18.8308Z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      type: String,
      default: '#FF6600',
    },
  },
};
</script>
